export default __webpack_public_path__ + "static/media/img_3.9bbb6f85.png";